module.exports = __webpack_public_path__ + "img/nt109-01-81-1.prt.4fde0389.jpg";